export default __webpack_public_path__ + "static/media/flask_life_full.c0c702f1.svg";